import { GlobalConstants } from "../constants";

export function isShiUserEmail(emailAddress: string): boolean {
  return GlobalConstants.shiUserEmailDomains.some((emailDomain) =>
    emailAddress.toLowerCase().includes(emailDomain.toLowerCase())
  );
}